<template>
  <div id="contestDetail">
    <img class="theme" src="@/assets/img/detailPic/theme.webp" alt="" />
    <div id="theme-video" class="theme-video"></div>
    <img class="progress" src="@/assets/img/detailPic/progress.webp" alt="" />
    <div class="theme-color">
      <img class="theme-color-img" src="@/assets/img/detailPic/theme-color.webp" alt="">
    </div>
    <div class="prize-wrap">
      <a class="prize-btn" href="https://mp.weixin.qq.com/s/bL9PmJYEOzLRcZczpVny0Q"></a>
      <img class="prize" src="@/assets/img/detailPic/prize.webp" alt="" />
    </div>
    <div class="judge-wrap">
      <div class="link-wrap">
        <a class="link" v-for="item in judgeList.list" :key="item" :href="item"></a>
      </div>
      <img class="judge" src="@/assets/img/detailPic/judge.webp" alt="" />
    </div>
    <div class="weibo-wrap">
      <img class="weibo" src="@/assets/img/detailPic/weibo.webp" alt="" />
      <img class="weibo2"
        @click="goLink('https://color.benq.com.cn/?mark_id=999_reallog_mark_ad%3A999%7CWeiboADNatural#/')"
        src="@/assets/img/detailPic/weibo2.webp" alt="">
    </div>
    <img class="about"
      @click="goLink('https://pro.m.jd.com/mall/active/qAJnTqVPM7BmoMjTJyUjY46EoWd/index.html?jd_pop=8bd84f74-6a3a-46e3-9520-935e8af75583&ad_od=1&mtm_source=kepler-open&mtm_subsource=d391e66cee144a13819a5421cd834e6f&utm_source=kong&utm_medium=zssc&utm_campaign=t_1001006693_19259_78106_null&utm_term=8bd84f74-6a3a-46e3-9520-935e8af75583-p_0-at_19259_78106_null&extension_id=eyJhZCI6IiIsImNoIjoiOCIsInNob3AiOiIxMDAwMDAwNDM3Iiwic2t1IjoiIiwidHMiOiIxNzQ1ODk4MTY4In0=')"
      src="@/assets/img/detailPic/about.webp" alt="" />
    <elImageViewer v-if="showViewer" @close="closeViewer" :url-list="invited.viewerImgList" :z-index="3000">
    </elImageViewer>
  </div>
</template>

<script>
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
import Player from 'xgplayer';
export default {
  name: "contestDetail",
  setup() {
    const showViewer = ref(false)
    const router = useRouter();
    const judgeList = reactive(
      {
        list: [
          "https://weibo.com/u/1990450131",
          "https://oyart.zcool.com.cn/",
          "https://www.tigerpan.com/works",
          "",
          "https://www.ad.tsinghua.edu.cn/info/1227/15438.htm",
          "",
          "http://www.zhelongxu.com",
          "",
          "",
          "https://claudzzz.artstation.com ",
          "https://www.caa.edu.cn/sz/zzfjs/fufan/jianli/index.html",
          "",
          "",
          "https://www.xiaohongshu.com/user/profile/5ed6485a000000000101ebbe?xsec_token=YBd8aG9OaQcAMQQ3F78GZiMqhjNPnTLO_JdInXMuIlXSs=&xsec_source=app_share&xhsshare=WeixinSession&appuid=5ed6485a000000000101ebbe&apptime=1744354109&share_id=1dac93f2b69f49fd94d12ce115446d98&wechatWid=d9ea97045c5193705f19f4019dc026ac&wechatOrigin=menu",
          "",
          "",
          "",
          "",
          "",
          ""
        ]
      }
    )
    const invited = reactive({
      invitedList1: [
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/invited/1-1.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/invited/1-2.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/invited/1-3.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/invited/1-4.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/invited/1-5.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/invited/1-6.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/invited/1-7.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/invited/1-8.jpg",
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/invited/1-9.jpg",
      ],
      invitedList2: [
        "http://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/invited/2-1.jpg"
      ],
      viewerImgList: []
    })
    function uploadFile() {
      router.push({ path: "/upLoadFile" });
      document.documentElement.scrollTop = 820;
    }
    function goLink(item) {
      window.location.href = item;
    }
    function onPreview(index, type) {
      showViewer.value = true
      let tempImgList
      if (type === 1) {
        tempImgList = [...invited.invitedList1];
      } else {
        tempImgList = [...invited.invitedList2];
      }
      let temp = [];
      for (let i = 0; i < index; i++) {
        temp.push(tempImgList.shift());
      }
      invited.viewerImgList = tempImgList.concat(temp);
    }
    // 关闭查看器
    function closeViewer() {
      showViewer.value = false
    }

    return {
      uploadFile,
      judgeList,
      goLink,
      invited,
      showViewer,
      onPreview,
      closeViewer
    };
  },
  methods: {
    initVideo(id, url, poster) {
      let player = new Player({
        id,
        url,
        poster,
        definitionActive: 'hover',
        width: '325',
        height: '188.5',
      });
      player.emit('resourceReady');
    }
  },
  mounted() {
    this.initVideo('theme-video',
      'https://v-sjds.benq.com.cn/vod-3d2c01/b0c21c2d24dc71f0a7ac6732b68e0102/6e79e98c18d045d8a275a819f15c3bc3-171849f08a9ac82f448a9b3e979b8740-hd.mp4',
      'https://benqgroup.oss-cn-hangzhou.aliyuncs.com/design-competition/%E7%94%9F%E7%94%9F%E4%B8%8D%E6%81%AF-%E5%A4%A7%E8%B5%9BKV-1920x1080.png'
    )
  }
};
</script>

<style lang="less" scoped>
@font-face {
  font-family: "FZLTHJW";
  src: url("../assets/fonts/FZLTHJW.TTF") format("truetype");
}

#contestDetail {
  padding: 120px 0 120px 0;
  box-sizing: border-box;
  background-image: url("../assets/img/detailPic/bg.jpg");
  background-size: cover;
  background-position: center;
  position: relative;

  &>img {
    display: block;
    margin: 0 auto;
  }

  .theme {
    margin-bottom: 60px;
    width: 956px;
    height: 592px;
  }

  .theme-video {
    display: block;
    width: 925px;
    height: 520px;
    // background-image: url('../assets/img/detailPic/video.webp');
    // background-size: cover;
    // background-position: center;
    margin: 0 auto;
    margin-bottom: 110px;


  }

  ::v-deep .xgplayer-skin-default {
    background-color: transparent !important;
  }

  .progress {
    width: 1127px;
    height: 393px;
    margin-bottom: 106px;
  }

  .theme-color {
    width: 1125px;
    height: 711px;
    margin: 0 auto;

    &>img {
      width: 1125px;
      height: 711px;
      margin: 0 auto;
    }

    margin-bottom: 120px;
  }

  .prize-wrap {
    width: 1125px;

    margin: 0 auto;
    position: relative;

    .prize-btn {
      display: block;
      text-decoration: none;
      /* 去除默认的下划线 */
      color: #000;
      /* 去除默认的颜色和点击后变化的颜色 */
      width: 302px;
      height: 68px;
      background-position: center;
      background-size: contain;
      border-radius: 8px;
      position: absolute;
      bottom: -4px;
      left: 50%;
      transform: translateX(-50%);
    }

    .prize {
      display: block;
      width: 1125px;
      height: 2053px;
      margin: 0 auto;
      margin-bottom: 121px;
    }
  }

  .judge-wrap {
    width: 1152px;
    height: 3144px;
    margin: 0 auto;
    margin-bottom: 144px;
    position: relative;

    .judge {
      display: block;
      width: 1152px;
      margin: 0 auto;
      margin-bottom: 59px;
    }

    .link-wrap {
      position: absolute;
      top: 250px;
      left: 0;
      right: 0;
      width: 1130px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: left;

      .link {
        display: block;
        width: 205px;
        height: 442px;
        margin-bottom: 130px;
        margin-right: 3px;
        // background-color: #fff;
      }
    }

  }

  .weibo-wrap {
    width: 1125px;
    height: 1380px;
    margin: 0 auto;
    position: relative;
    margin-bottom: 125px;

    .weibo {
      display: block;
      width: 1125px;
      margin: 0 auto;
      margin-bottom: 29px;
    }

    .weibo2 {
      display: block;
      width: 1125px;
      margin: 0 auto;
      cursor: pointer;
    }
  }

  .about {
    cursor: pointer;
    width: 1125px;
    height: 1355px;
  }

  ::v-deep .xgplayer-skin-default .xgplayer-poster {
    background-size: contain;
    background-repeat: no-repeat;
  }
}
</style>
